// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.followup-badge-wrapper {
  position: fixed;
  bottom: 30px;
  left: 30px;
  z-index: 1000;
}

/* Floating Button */
.followup-btn {
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff !important;
  border-color: #fff !important;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  transition: transform 0.3s ease;
}

.followup-btn:hover {
  transform: scale(1.1);
  background-color: #f0f8ff !important;
}

/* Bounce animation when new follow-ups available */
.bounce {
  animation: bounce 1.5s infinite;
}

@keyframes bounce {
  0%,
  20%,
  50%,
  80%,
  100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
}
`, "",{"version":3,"sources":["webpack://./src/followupButton.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,YAAY;EACZ,UAAU;EACV,aAAa;AACf;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,6BAA6B;EAC7B,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA,mDAAmD;AACnD;EACE,+BAA+B;AACjC;;AAEA;EACE;;;;;IAKE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF","sourcesContent":[".followup-badge-wrapper {\n  position: fixed;\n  bottom: 30px;\n  left: 30px;\n  z-index: 1000;\n}\n\n/* Floating Button */\n.followup-btn {\n  width: 60px;\n  height: 60px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #fff !important;\n  border-color: #fff !important;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);\n  transition: transform 0.3s ease;\n}\n\n.followup-btn:hover {\n  transform: scale(1.1);\n  background-color: #f0f8ff !important;\n}\n\n/* Bounce animation when new follow-ups available */\n.bounce {\n  animation: bounce 1.5s infinite;\n}\n\n@keyframes bounce {\n  0%,\n  20%,\n  50%,\n  80%,\n  100% {\n    transform: translateY(0);\n  }\n  40% {\n    transform: translateY(-10px);\n  }\n  60% {\n    transform: translateY(-5px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
